import { PageInfo } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/hooks/useProductRows';
import { useWebsiteProductRow } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/hooks/useProductRows/useWebsiteProductRow';
import { ProductRowItem } from '@apps/admin/routes/Dashboard/components/DashboardContentV2/PrimaryDashboardContent/ProductRowItem';
import { useTranslation } from '@shared/core';
import { ProductVerticals } from '@shared/core/productVerticals/productVerticals.types';
import React from 'react';

export const PageListDialog = ({
  eventPages,
  productVerticals,
  isOpen,
  onToggle,
  onClose
}: {
  eventPages: PageInfo[];
  productVerticals: ProductVerticals;
  isOpen: boolean;
  onToggle: () => void;
  onClose: () => void;
}) => {
  const { t2 } = useTranslation('adminDashboardV2');
  const { website: websiteTranslations } = t2('sections');
  const websiteStrings = websiteTranslations;

  const websiteProductRow = useWebsiteProductRow(eventPages, productVerticals);
  const editPages = websiteProductRow.children.find(item => item.title === websiteStrings.children.editPages.title);

  if (!editPages) return null;

  return <ProductRowItem {...editPages} isDialogOnly={true} externalIsOpen={isOpen} externalOnToggle={onToggle} externalOnClose={onClose} />;
};
